module.exports = __webpack_public_path__ + "media/icons/osoba-prywatna-grey-fd9bd5ec.png";